import React, { useEffect } from "react";

/**
 * Shown only in a staging build (REACT_APP_STAGING=1): a pill on every screen so
 * nobody takes test data for the real thing, and a tab title that says so. Production
 * builds render nothing at all.
 */
export const IS_STAGING = process.env.REACT_APP_STAGING === "1";

const StagingBanner = () => {
  useEffect(() => {
    if (!IS_STAGING) return undefined;

    const mark = () => {
      if (!document.title.startsWith("[STAGING]")) document.title = `[STAGING] ${document.title}`;
    };
    mark();

    // The app sets its own title as it navigates; keep ours in front
    const observer = new MutationObserver(mark);
    observer.observe(document.querySelector("title"), { childList: true });
    return () => observer.disconnect();
  }, []);

  if (!IS_STAGING) return null;

  return (
    <div
      role="note"
      className="pointer-events-none fixed bottom-2 left-1/2 z-[100] -translate-x-1/2 rounded-full bg-amber-500 px-3 py-1 text-xs font-bold uppercase tracking-wide text-black shadow-lg"
    >
      Staging · test data
    </div>
  );
};

export default StagingBanner;
